import { type Issue } from './types';

export function findIssueAri(issues: Issue[], issueKey: string): string {
	const issue = issues.find((issue) => issue.issueKey === issueKey);
	return issue!.ari;
}

// Formats a date string to a localised short format (e.g. "3 Oct 2026").
// Falls back to the original string if parsing fails.
export const formatDate = (dateStr: string | undefined): string | undefined => {
	if (!dateStr) {
		return undefined;
	}
	try {
		return new Date(dateStr).toLocaleDateString(undefined, {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
		});
	} catch {
		return dateStr;
	}
};
